import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Notice = {
  notice_id?: number; // 공지사항 idx
  notice_name?: string; // 공지사항 제목
  notice_content?: string; // 공지사항 내용
  is_show?: string; // 노출 여부
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Notice
   * --
   */
  getNotices: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_NOTICE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Notice
   * --
   */
  getNotice: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_NOTICE, { notice_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Notice
   * --
   */
  createNotice: async (body: Notice) => {
    try {
      const res = await $http.post(APIConstant.CREATE_NOTICE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Notice
   * --
   */
  updateNotice: async (body: Notice) => {
    try {
      const { notice_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_NOTICE, {
        notice_id: notice_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Notice
   * --
   */
  deleteNotice: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.DELETE_NOTICE, {
        notice_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
